module.exports = __webpack_public_path__ + "static/media/screens_paraphrase.64103972.jpg";